import { Md5 } from 'ts-md5';

export class Credentials {
  account: string;
  password: string;
  userType: string;

  constructor(account: string, password: string, userType: string = 'employee') {
    this.account = account;
    this.password = Md5.hashStr(password);
    this.userType = userType;
  }

  toJSON() {
    return {
      account: this.account,
      password: this.password,
      userType: this.userType,
    };
  }
}
